import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1f382d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("全局搜索")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消搜索")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("搜索名称")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("搜索说明")
const _hoisted_13 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_14 = { class: "card-body table-responsive p-0" }
const _hoisted_15 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_16 = { ref: "tableTr" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "ID", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "robotStatus" }, "状态", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "robotFrom" }, "机器人来源", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "robotAccessToken",
  class: "normal-width text-left"
}, "机器人AccessToken", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "robotKeyword" }, "机器人关键词", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createName" }, "创建姓名", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createTime" }, "创建时间", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyName" }, "修改姓名", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyTime" }, "修改时间", -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["colspan"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_30 = { class: "table-btn-group" }
const _hoisted_31 = { class: "btn-group" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { class: "text-left" }
const _hoisted_38 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_39 = { class: "content-modal" }
const _hoisted_40 = { class: "row" }

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_app_alert = _resolveComponent("app-alert")
  const _component_app_select_level = _resolveComponent("app-select-level")
  const _component_app_select_from_db = _resolveComponent("app-select-from-db")
  const _component_app_select_from_dictionary = _resolveComponent("app-select-from-dictionary")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_switch_number = _resolveComponent("app-switch-number")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.Auth('/module/robot/add'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addModalOpen && _ctx.addModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "add" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.Auth('/module/robot/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_search, {
                    key: 0,
                    ref: "tableSearch",
                    modelValue: _ctx.tableRequestItem.searchKey,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.tableRequestItem.searchKey) = $event)),
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/module/robot/export')
                  }, {
                    "dropdown-search-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hyper-text-themes hand",
                        onClick: _cache[1] || (_cache[1] = $event => (_ctx.searchFunction('all')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-sharp",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchCancel()))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_9
                      ]),
                      _hoisted_10,
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.searchFunction('org_type_name')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_11
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[4] || (_cache[4] = $event => (_ctx.searchFunction('org_type_remark')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_12
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[7] || (_cache[7] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.Auth('/module/robot/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_16, [
                      _hoisted_17,
                      _hoisted_18,
                      _hoisted_19,
                      _createElementVNode("th", {
                        field: "orgCode",
                        class: "table-search-lock hand active",
                        onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.orgCodeLevelModalOpen && _ctx.orgCodeLevelModalOpen(...args)))
                      }, "组织代码"),
                      _createElementVNode("th", {
                        field: "orgCodeName",
                        class: "table-search-lock hand active",
                        onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.orgCodeLevelModalOpen && _ctx.orgCodeLevelModalOpen(...args)))
                      }, "所属组织"),
                      _createElementVNode("th", {
                        field: "cockpitCode",
                        class: "table-search-lock hand active",
                        onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.cockpitCodeLevelModalOpen && _ctx.cockpitCodeLevelModalOpen(...args)))
                      }, "驾驶舱编号"),
                      _createElementVNode("th", {
                        field: "layerIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[11] || (_cache[11] = $event => (_ctx.dictionaryModalOpen('layerId')))
                      }, "设备层号"),
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26
                    ], 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_29
                          ], 8, _hoisted_28)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.robotId,
                        class: _normalizeClass({'text-red': parseInt(item.robotStatus)===2})
                      }, [
                        _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            (_ctx.Auth('/module/robot/mod'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.modModalOpen(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "settings-outline" })
                                ], 8, _hoisted_32))
                              : _createCommentVNode("", true),
                            (_ctx.Auth('/module/robot/del'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.delAlert(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "trash-outline" })
                                ], 8, _hoisted_33))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (parseInt(item.robotStatus)===1)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              class: "hand",
                              onClick: $event => (_ctx.toggleStatus(item))
                            }, [
                              _createVNode(_component_svg_icon, {
                                name: "checkmark-circle-outline",
                                class: "hyper-text-themes"
                              })
                            ], 8, _hoisted_34))
                          : (parseInt(item.robotStatus)===2)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                class: "hand",
                                onClick: $event => (_ctx.toggleStatus(item))
                              }, [
                                _createVNode(_component_svg_icon, {
                                  name: "close-circle-outline",
                                  class: "text-red"
                                })
                              ], 8, _hoisted_35))
                            : (_openBlock(), _createElementBlock("td", _hoisted_36, "未知")),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.orgCode.value? 'active' : ''])
                        }, _toDisplayString((item.orgCode === -1) ? "全部" : item.orgCode), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.orgCode.value? 'active' : ''])
                        }, _toDisplayString(item.orgCodeName), 3),
                        _createElementVNode("td", null, _toDisplayString(item.cockpitCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.layerIdName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.robotFrom), 1),
                        _createElementVNode("td", _hoisted_37, _toDisplayString(item.robotAccessToken), 1),
                        _createElementVNode("td", null, _toDisplayString(item.robotKeyword), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyTime), 1)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_app_table_page, {
            class: "card-footer",
            pageItems: _ctx.tablePageItems,
            pageFunction: _ctx.getList
          }, null, 8, ["pageItems", "pageFunction"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_39, [
      _createVNode(_component_app_alert, { ref: "delModal" }, null, 512),
      _createVNode(_component_app_select_level, {
        ref: "orgCodeLevel",
        levelType: "select",
        levelApi: _ctx.getOrgApi,
        selectItem: _ctx.tableRequestItem.lockItem.orgCode,
        maxParentId: _ctx.authUser.orgCode,
        selectFunction: _ctx.orgCodeLevelFunction,
        searchFieldList: _ctx.orgCodeLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "cockpitCodeLevel",
        levelType: "onLest",
        levelApi: _ctx.getCockpitCodeAPI,
        maxParentId: _ctx.authUser.orgCode,
        selectItem: _ctx.tableRequestItem.lockItem.cockpitCode,
        selectFunction: _ctx.cockpitCodeLevelFunction,
        searchFieldList: _ctx.cockpitCodeLevelSearchField
      }, null, 8, ["levelApi", "maxParentId", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "dictionaryLevel",
        levelType: "select",
        levelApi: _ctx.getDictionaryAPI,
        selectItem: this.tableRequestItem.lockItem[this.currentLockCode],
        maxParentId: this.tableRequestItem.lockItem[this.currentLockCode].parent,
        selectFunction: _ctx.dictionaryFunction,
        searchFieldList: _ctx.dictionarySearchField
      }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_modal, {
        ref: "editModal",
        title: _ctx.editModalTitle,
        submitButtonName: _ctx.editModalSubmitButtonName,
        size: "lg",
        submitFunction: _ctx.editModalSubmit,
        submitAfterClose: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_40, [
            (_ctx.enableOrgCode)
              ? (_openBlock(), _createBlock(_component_app_select_from_db, {
                  key: 0,
                  ref: "orgCodeSelect",
                  class: "col-lg-12",
                  label: "所属组织",
                  modelValue: _ctx.editModalItem.orgCode,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.editModalItem.orgCode) = $event)),
                  searchApi: _ctx.orgCodeSelectApi
                }, null, 8, ["modelValue", "searchApi"]))
              : _createCommentVNode("", true),
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-12",
              label: "驾驶舱编号",
              modelValue: _ctx.editModalItem.projectId,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.editModalItem.projectId) = $event)),
              searchApi: _ctx.cockpitCodeSelectApi,
              "onUpdate:change": _ctx.cockpitCodeChange
            }, null, 8, ["modelValue", "searchApi", "onUpdate:change"]),
            _createVNode(_component_app_select_from_dictionary, {
              class: "col-lg-12",
              label: "设备层号",
              modelValue: _ctx.editModalItem.layerId,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.editModalItem.layerId) = $event)),
              extend: "全部",
              code: "layerId"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-12",
              label: "机器人来源",
              modelValue: _ctx.editModalItem.robotFrom,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.editModalItem.robotFrom) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-12",
              label: "机器人AccessToken",
              modelValue: _ctx.editModalItem.robotAccessToken,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.editModalItem.robotAccessToken) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-12",
              label: "关键词",
              modelValue: _ctx.editModalItem.robotKeyword,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((_ctx.editModalItem.robotKeyword) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_switch_number, {
              class: "col-lg-12",
              label: "状态",
              modelValue: _ctx.editModalItem.robotStatus,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.editModalItem.robotStatus) = $event)),
              enableName: "启用",
              disabledName: "禁用"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["title", "submitButtonName", "submitFunction"])
    ])
  ]))
}